import { createActions } from 'reduxsauce';
import { removeSelectedItem } from '@iso/lib//helpers/CRUD';

export const { Types: types, Creators: actions } = createActions({
    requestDeletePaymentMethod: ['id'],
    deletePaymentMethodSucceeded: ['id'],
    deletePaymentMethodFailed: ['error'],
});

export default {
    [types.REQUEST_DELETE_PAYMENT_METHOD]: (state, { id }) => ({
        ...state,
        delete: {
            ...state.delete,
            id,
            loading: true,
            error: null,
        },
    }),
    [types.DELETE_PAYMENT_METHOD_SUCCEEDED]: (state, { id }) => ({
        ...state,
        data: removeSelectedItem(state.data, id),
        delete: {
            ...state.delete,
            id: null,
            loading: false,
        },
    }),
    [types.DELETE_PAYMENT_METHOD_FAILED]: (state, { error }) => ({
        ...state,
        delete: {
            ...state.delete,
            id: null,
            loading: false,
            error,
        },
    }),
};
